import { DATE_FORMAT_SHORT, UIMenuItem, UITab } from '@constants';
import { Prototype } from '@core';
import { useCheckScreenWithCallback } from '@hooks';
import { ClickAwayListener } from '@material-ui/core';
import React, { memo, useMemo, useState, useRef, useCallback } from 'react';
import trans from 'translation';
import { KContainer, KTab, KTabInstance, KLabel, KButton } from 'uikit';
import { KCalendar } from 'uikit-common';

import WaitingTime from './components/STCWaitingTime';
import TripSummary from './components/TripSummary';

const WaitingTrip = () => {
  const calendarRef = useRef<any>();
  const [date, setDate] = useState(new Date());
  const isNow = useMemo(
    () =>
      Prototype.date.toMoment(date as any)?.isSame(Prototype.date.now(), 'd'),
    [date]
  );
  const tabRef = useRef<KTabInstance>(null);
  const [tabIndex, setTabIndex] = useState(0);

  const cb = useCallback(
    () => [
      {
        code: UITab.WaitingTime,
        label: trans('waiting_time')
      },
      {
        code: UITab.TripSummary,
        label: trans('trip_summary')
      }
    ],
    []
  );

  const tabs = useCheckScreenWithCallback(cb, UIMenuItem.Dashboard);

  const content = useMemo(() => {
    return (
      <KTab.White
        marginB="0.5rem"
        marginT={0}
        spacing="0rem"
        typo="TextNmMedium"
        //@ts-ignore
        marginH={-16}
        height={50}
        ref={tabRef}
        tabIndex={tabIndex}
        onChangeTab={setTabIndex}
        tabs={tabs}
      />
    );
  }, [tabIndex, tabs]);

  const rightNode = useMemo(() => {
    return (
      <KContainer.View row alignItems="center">
        <KLabel.Text color={'#FF0000'} typo="TextMdMedium">
          {Prototype.date
            .toMoment(date as any)
            ?.format(
              isNow ? `[Today] ${DATE_FORMAT_SHORT}` : DATE_FORMAT_SHORT
            )}
        </KLabel.Text>

        <KContainer.View style={{ position: 'relative' }}>
          <KButton.Outline
            icon={'EventNote'}
            title={trans('calendar')}
            onPress={() => calendarRef.current?.show()}
            marginL="1rem"
          />
          <KCalendar.Base
            ref={calendarRef}
            onChange={setDate}
            ClickAwayListener={ClickAwayListener}
          />
        </KContainer.View>
      </KContainer.View>
    );
  }, [date, isNow]);

  return (
    <KContainer.Card
      marginT={0}
      dp="flex"
      overflow="hidden"
      alignItems="stretch"
      flexG={1}
      // minH={DASHBOARD_CONTENT_HEIGHT - 12 * 2 - 210 - 4 * 2}
      // maxH={DASHBOARD_CONTENT_HEIGHT - 12 * 2 - 210 - 4 * 2}
      header={{
        content,
        rightNode
      }}
    >
      <KContainer.View
        overflow="hidden"
        alignItems="stretch"
        flexG={1}
        dp="flex"
      >
        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.WaitingTime)}
        >
          <WaitingTime currentDate={date} />
        </KTab.Panel>
        <KTab.Panel
          value={tabIndex}
          index={tabs.findIndex(i => i.code === UITab.TripSummary)}
        >
          <TripSummary currentDate={date} />
        </KTab.Panel>
      </KContainer.View>
    </KContainer.Card>
  );
};

export default memo(WaitingTrip);
